import { render, staticRenderFns } from "./DamagesCompensationForcedRows.vue?vue&type=template&id=3929221e"
import script from "./DamagesCompensationForcedRows.vue?vue&type=script&lang=ts"
export * from "./DamagesCompensationForcedRows.vue?vue&type=script&lang=ts"
import style0 from "./DamagesCompensationForcedRows.vue?vue&type=style&index=0&id=3929221e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports